
import { ReportBill } from "./ReportBill"
import React from 'react';
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css";


export const Bill = () => {

    return (
        <div className="w-full flex flex-col">

            <ReportBill />
            
        </div>
    )
}